import { useState } from 'react';
import styled from 'styled-components';

import CirclePlusIcon from '../../svgs/CirclePlusIcon';
import PresetPreview from './PresetPreview';

import type { Preset, Template } from '../textProcessor/TextBrandingService';

// Mostly copied from GlobalKaraokePresetSelect.tsx, but adapted for user templates
export default function KaraokeTemplateSelect({
  produceKaraokeText,
  templates,
  onAddTemplateButtonClick,
}: {
  produceKaraokeText: () => Promise<void>;
  templates: Template[];
  onAddTemplateButtonClick: () => void;
}) {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  return (
    <Section>
      <SectionText>
        My Templates{' '}
        <ClickableIconWrapper
          type="button"
          onClick={onAddTemplateButtonClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          aria-label="Add new template"
        >
          <CirclePlusIcon
            width="16"
            height="16"
            color={isHovered ? '#F2D093' : '#848484'}
          />
        </ClickableIconWrapper>
      </SectionText>
      <PresetsContainer>
        {templates.map((t, i) => (
          <PresetPreview
            key={String(t.id ?? i)}
            preset={t as Preset}
            produceKaraokeText={produceKaraokeText}
          />
        ))}
      </PresetsContainer>
    </Section>
  );
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  align-self: stretch;
`;

const SectionText = styled.div`
  color: #949494;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 159%; /* 15.9px */
  display: flex;
  align-items: center;
  gap: 4px;
`;

const PresetsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-self: stretch;
`;

const ClickableIconWrapper = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4px;
  margin: -4px; /* expand hit area without shifting layout */
  line-height: 0;
`;
